import React from 'react';
import styled from 'styled-components';

import mixin from '../../_foundations/Mixin';
import { Separator } from '../../_layouts';

export const DropdownComponent = styled.span``;

export const DropdownPopover = React.memo(styled.div`
  ${mixin.elevation({ level: 200 })}
  ${mixin.text({ size: 100, strong: true })};
  padding: 0.5rem;
  min-width: 7.5rem;
  border-radius: 0.75rem;
  background-color: #fff;
  max-width: 16rem;
  z-index: 90002;

  & ${Separator} {
    height: 1px;
  }
`);
